import { render, staticRenderFns } from "./text-field-secondary.vue?vue&type=template&id=6e27fbc6&scoped=true&"
import script from "./text-field-secondary.vue?vue&type=script&lang=js&"
export * from "./text-field-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27fbc6",
  null
  
)

export default component.exports